export const LIMITS = {
    answer: 1000, // unexpected / made / proud / about free-text answers
    name: 100,
    location: 100,
} as const;
